import { queryOptions } from "@tanstack/react-query"
import { GatedRegisterSessionPOSTRequest } from "ipctg-inflow-types/InFlowGatedAPI"

import api from "@/utilities/api"

import { GatedRegisterSessionError } from "@/utilities/expectedErrors"

import { GATED_BASE_KEY, REGISTER_BASE_KEY } from "./keys"

export const registerQueryOptions = (args: GatedRegisterSessionPOSTRequest) => {
  return queryOptions({
    queryKey: [GATED_BASE_KEY, REGISTER_BASE_KEY, args],
    queryFn: async () => {
      const rsp = await api.gated.registerSession.POST({ ...args })

      if ("failReason" in rsp) {
        throw new GatedRegisterSessionError(rsp.failReason)
      }

      return rsp
    },
    retry: false,
  })
}
